import React from 'react';
import CrmContacts from '../Crm/CrmContacts';

const PortalContacts = () => {
  return (
    <React.Fragment>
      <CrmContacts />
    </React.Fragment>
  );
};

export default PortalContacts;
